<template>
    <div>
        <vs-row class="buscadorAlumnos align-items-center">
            <vs-col sm="12" :lg="persona_rol.tipoUserPrincipal != 'alumno' && persona_rol.tipoUserPrincipal != 'familiar' ? '7' : '12'" class="d-flex">
                <menu-perfiles :instituciones="instituciones" :hermanos="hermanos" :general="general" :personaRol="persona_rol" @usuario="getGeneral"></menu-perfiles>
            </vs-col>
            <vs-col sm="12" lg="5" v-if="persona_rol.tipoUserPrincipal != 'alumno' && persona_rol.tipoUserPrincipal != 'familiar' && persona_rol.tipoUserPrincipal != 'docente'" >
                <buscador-avanzado class="ml-auto"></buscador-avanzado>
            </vs-col>
        </vs-row>
        <div class="menuRol shadow-sm mb-2"   style="position: relative">
            <menu-general :menuPermisos="menuPermisos" :general="general" :personaRol="persona_rol" :ruta_url="ruta_url" @opcionMenu="opcionMenu" :filtrosPadresFinanzas="filtrosPadresFinanzas"></menu-general>
        </div>
        <div v-show="(persona_rol.tipoUserPrincipal == 'alumno' || persona_rol.tipoUserPrincipal == 'familiar') && !general.datos" class="px-4 mt-4 seleccionAlumno">
            <div class="cardInfo shadow-sm text-center p-4">
                <h2 class="mb-3">Favor de seleccionar a un alumno para visualizar su información.</h2>
                <img src="/img/seleccion.png">
            </div>
        </div>
        <div v-show="general.datos">
            <vs-row v-show="showApartado">
                <vs-col sm="12" lg="4" class="px-4 mt-4">
                    <info-card class="cardInfo shadow-sm" :info_general="info_general" :general="general" :estatus="estatus"></info-card>
                </vs-col>
                <vs-col sm="12" lg="8" class="px-4 mt-4">
                    <perfil class="cardInfo shadow-sm" v-show="menuShow == 'perfil'" :general="general" :personaRol="persona_rol" @refreshComponent="getInfoGeneral"></perfil>
                    <datos-medicos class="cardInfo shadow-sm" v-show="menuShow == 'datos-medicos'" :general="general" :proceso="proceso" @refreshComponent="getInfoGeneral"></datos-medicos>
                    <datos-referenciales class="cardInfo shadow-sm" v-show="menuShow == 'datos-referenciales'" :general="general" @refreshComponent="getInfoGeneral"></datos-referenciales>
                    <familiares class="cardInfo shadow-sm" v-show="menuShow == 'familiares'" :general="general" @refreshComponent="getInfoGeneral"></familiares>
                    <datos-fiscales  class="cardInfo shadow-sm" v-show="menuShow == 'datos-fiscales'" :general="general" :proceso="proceso" @refreshComponent="getInfoGeneral"></datos-fiscales>
                    <bajas-suspenciones class="cardInfo shadow-sm" v-show="menuShow == 'bajas-suspensiones'" :general="general" :institucion_id_url="institucion_id_url" :proceso="proceso" :estatus="estatus" @refreshComponent="getInfoGeneral"></bajas-suspenciones>
                    <bajas-alumno  class="cardInfo shadow-sm" v-show="menuShow == 'bajas-alumno'"  :general="general" :personaRol="persona_rol" :institucion_id_url="institucion_id_url" :proceso="proceso" ></bajas-alumno>
                    <becas class="cardInfo shadow-sm" v-show="menuShow == 'becas'" :general="general" :institucion_id_url="institucion_id_url" :csrf_token="csrf_token"></becas>
                    <gestion-accesos class="cardInfo shadow-sm" v-show="menuShow == 'gestion-de-accesos'" :general="general" :csrf_token="csrf_token" @refreshComponent="getInfoGeneral" :proceso="proceso"></gestion-accesos>
                    <proceso-admision class="cardInfo shadow-sm" v-show="menuShow == 'proceso-de-admision'" :general="general" :informacion="general.datos" :personaId="personaId" @refreshComponent="getInfoGeneral"></proceso-admision>
                    <correos class="cardInfo shadow-sm" v-show="menuShow == 'historico-correos'" :general="general" :csrf_token="csrf_token" @refreshComponent="getInfoGeneral"></correos>
                    <descarga-material class="cardInfo shadow-sm" v-show="menuShow == 'descargar-material'" :general="general" :registroAcademico="registroAcademico" :registroCounter="registroCounter"></descarga-material>
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col w="12" class="mt-4">
                    <gestion-finanzas v-if="(general && general.idAlumno) && menuPermisos.includes('gestion-finanzas-v1')" v-show="menuShow == 'gestion-finanzas-v1'" :personaId="general.idAlumno" @ejecutarFinanzas="getEjecutarFinanzas" :personaRol="personaRol" @filtroPadres="filtropadres"></gestion-finanzas>
                    <div v-if="!verFinanzas" v-show="menuShow == 'ver-finanzas-alumno'">
                        <h3 class="text-center">Espere un momento, se esta cargando la vista</h3>
                        <md-progress-bar md-mode="indeterminate"></md-progress-bar>
                    </div>
                    <finanzas-alumno v-if="general && general.idAlumno && verFinanzas" class="cardInfo shadow-sm" v-show="menuShow == 'ver-finanzas-alumno'" :personaId="general.idAlumno" :personaRol="personaRol" :general="general"></finanzas-alumno>
                    <inscripcion-academica v-if="general && general.idAlumno" v-show="menuShow == 'inscripcion-academica'" :persona_id="general.idAlumno" :csrf_token="csrf_token" :persona="personaRol" @infoRegistroAcademico="infoRegistroAcademico" :institucionesUsuario="instituciones"></inscripcion-academica>
                    <expediente-digital v-if="general && general.idAlumno" v-show="menuShow == 'expediente-digital'" :personaId="general.idAlumno"></expediente-digital>
                    <boleta-alumno v-if="general && general.idAlumno" v-show="menuShow == 'ver-calificaciones'" :persona="personaRol" :personaId="general.idAlumno" :general="general" :estatus="estatus"></boleta-alumno>
                    <mapa-academica v-if="general && general.idAlumno" v-show="menuShow == 'mapa-carga-academica'" :personaId="general.idAlumno"  ></mapa-academica>
                </vs-col>
            </vs-row>
        </div>
    </div>
</template>

<script>
import alumnos from '../../../api/requests/alumno'
import BuscadorAvanzado from '../../pages/header/HeaderSearchbar.vue'
import MenuPerfiles from './components/menu-perfiles.vue'
import InfoCard from './components/info-card.vue'
import MenuGeneral from './components/menu.vue'
import perfil from './components/perfil.vue'
import DatosMedicos from './components/datos-medicos.vue'
import DatosReferenciales from './components/datos-referenciales.vue'
import familiares from './components/familiares/familiares.vue'
import DatosFiscales from './components/datos-fiscales.vue'
import BajasSuspenciones from './components/bajas-suspenciones.vue'
import BajasAlumno from './components/bajas-suspenciones/bajas-suspenciones.vue'
import Becas from './components/becas/becas.vue'
import GestionAccesos from './components/gestion-accesos.vue'
import ProcesoAdmision from './components/proceso-admision/proceso-admision.vue'
import correos from './components/correos.vue'
import FinanzasAlumno from '../landing/cobranza.vue'
import GestionFinanzas from '../landing-profesores/landing.vue'
import InscripcionAcademica from '../landing/proceso-inscripcion/proceso-inscripcion.vue'
import ExpedienteDigital from '../landing/expediente-digital/expediente-digital.vue'
import BoletaAlumno from '../landing/boleta/boleta.vue'
import MapaAcademica from '../landing/mapa-inscripcion/mapa-inscripcion.vue'
import DescargaMaterial from './components/descarga-material/descargar-material.vue'

export default {
    props:[
        'personaRol',
        'csrf_token',
    ],
    data:()=>({
        hermanos: [],
        menuPermisos: [
            //OPCIONES DE PERFIL
            'perfil',
            'datos-medicos',
            'familiares',
            'datos-referenciales',
            'gestion-accesos',
            //OPCIONES DE FINANZAS
            'ver-finanzas-alumno',
            'gestion-finanzas',
            'ver-gestion-finanzas',
            'datos-fiscales',
            'gestion-finanzas-v1',
            //OPCIONES DE ACADEMICO
            'bajas-suspenciones',
            'becas',
            'gestion-de-accesos',
            'inscripcion-academica',
            'expediente-digital',
            //ESTE VA SOLITO
            'calificaciones',
            "perfil-visualizacion",
            "datos-medicos-visualizacion",
            "familiares-visualizacion",
            'proceso-admision'
        ],
        info_general: [],
        personaId: '',
        menuShow: '',
        general: {},
        actualizar_modulo: '',
        proceso: '',
        insitucion_url: '',
        institucion_id_url: '',
        idAlumno: '',
        showApartado: true,
        ruta_url: '',
        verFinanzas: false,
        cicloEscolar: '',
        registroAcademico: [],
        registroCounter: 0,
        instituciones: [],
        estatus: [],
        filtrosPadresFinanzas: {}
    }),
    components:{
        BuscadorAvanzado,
        MenuPerfiles,
        InfoCard,
        MenuGeneral,
        perfil,
        DatosMedicos,
        DatosReferenciales,
        familiares,
        DatosFiscales,
        BajasSuspenciones,
        BajasAlumno,
        Becas,
        GestionAccesos,
        ProcesoAdmision,
        correos,
        FinanzasAlumno,
        GestionFinanzas,
        InscripcionAcademica,
        ExpedienteDigital,
        BoletaAlumno,
        MapaAcademica,
        DescargaMaterial
    },
    created(){
        this.getInstitucionUsuario()
        this.getEstatusAlumno()
        const url = window.location.pathname.split('/')
        this.proceso = url[2]
        if(this.proceso != 'usuario'){
            let params = (new URL(document.location)).searchParams;
            let ciclo_escolar = params.get('ciclo_escolar');
            // const ciclo_escolar = ''
            // if(params){
            //     ciclo_escolar = params.get('ciclo_escolar');
            // }
            const id_alumno = url[3]
            this.personaId =  atob(id_alumno)
            this.idAlumno = this.personaId
            this.insitucion_url = url[5]
            this.institucion_id_url = atob(url[5])
            this.callAll(this.proceso, this.personaId, this.institucion_id_url, ciclo_escolar)
            // this.getHermanos(this.proceso, this.personaId)
            // this.getInfoGeneral(this.personaId, this.proceso)
            // this.getInformacionAlumno(this.personaId, this.proceso, this.institucion_id_url)
        }else{
            this.getHermanos(this.proceso, this.persona_rol.id)
        }
    },
    computed:{
        persona_rol(){
            return JSON.parse(this.personaRol)
        }
    },
    methods:{
        filtropadres(filtros){
            this.filtrosPadresFinanzas = filtros
        },
        async getInstitucionUsuario(){
            try {
                const response = await alumnos.getInstitucion()
                this.instituciones = response.data
                this.institucionId =  (new Date()).getTime()
            }
            catch(error){
                console.log(error)
            }
        },
        async getCicloDefault(institucion_id_url, personaId, proceso) {
            let params = {
                "institucion_id": institucion_id_url,
                "persona_id": personaId
            }
            const { data: response } = await alumnos.getCicloDefault(params) || {}
            const { opciones: info, default: val = null } = response || {}
            this.listCiclos = info instanceof Object ?  Object.values(info) : []
            this.cicloEscolar = val
            this.cicloId = (new Date()).getTime()
            this.getInfoGeneral(personaId, proceso, institucion_id_url)
        },
        async getEstatusAlumno(){
            try{
                const {data: response} = await alumnos.getEstatusAlumno()
                this.estatus = response
            }catch(error){
                console.error(error)
            }
        },
        getEjecutarFinanzas(valor){
            this.verFinanzas =  valor
        },
        callAll(proceso, personaId, institucion_id_url, ciclo_escolar){
            const loading = this.$vs.loading()
            this.getHermanos(proceso, personaId)
            if(proceso == 'alumno'){
                if(ciclo_escolar){
                    this.getInfoGeneral(personaId, proceso, institucion_id_url, ciclo_escolar)
                }else{
                    this.getCicloDefault(institucion_id_url, personaId, proceso)
                }
            }else{
                this.getInfoGeneral(personaId, proceso, institucion_id_url)
            }
            this.getInformacionAlumno(personaId, proceso, institucion_id_url)
            loading.close()
        },
        activeMenu(){
            
            let params = (new URL(document.location)).searchParams;
            this.ruta_url = params.get('valor');
            if(this.proceso == 'alumno'){
                if(this.ruta_url){
                    this.menuShow = this.ruta_url
                }else{
                    this.menuShow = 'perfil'
                }
            }else if(this.proceso == 'seguimiento'){
                if(this.ruta_url){
                    this.menuShow = this.ruta_url
                }else{
                    this.menuShow = 'proceso-de-admision'
                }
            }
        },
        getGeneral(instituto, personaId, prospecto, ciclo_escolar){
            const loading = this.$vs.loading()
            let proceso = ''
            if(prospecto == false){
                proceso = 'alumno'
            }else{
                proceso = 'prospecto'
            }
            this.idAlumno = personaId
            // this.getCicloDefault(instituto, personaId, proceso)
            this.getInfoGeneral(personaId, proceso, instituto, ciclo_escolar)
            this.getInformacionAlumno(personaId, proceso, instituto)
            this.proceso = proceso
            this.institucion_id_url = instituto
            loading.close()
        },
        async getInfoGeneral(personaId, proceso, instituto, ciclo_escolar){
                const loading = this.$vs.loading()
            try{
                const vm = this
                if(proceso == 'alumno'){
                    if(this.cicloEscolar || ciclo_escolar){
                        const params = {
                            institucion_id: instituto ? instituto : this.institucion_id_url,
                            ciclo_escolar_id: ciclo_escolar ? ciclo_escolar : this.cicloEscolar
                        }
                        const { data: response} = await alumnos.getInfoGeneral(personaId, params)
                        this.general = {
                            "datos": response,
                            "personaId": this.personaId,
                            "permisos": response.visibilidad,
                            "personaRol": JSON.parse(this.personaRol),
                            "proceso": proceso,
                            "idAlumno": response.persona_id
                        }
                    }
                    loading.close()
                }else if(proceso == 'seguimiento'){
                    const { data: response} = await alumnos.getInfoAlumnoSeguimientoGeneral(personaId, vm.insitucion_url)
                    this.general = {
                        "datos": response,
                        "personaId": this.personaId,
                        "permisos": response.visibilidad,
                        "personaRol": JSON.parse(this.personaRol),
                        "proceso": proceso,
                        "idAlumno": response.persona_id
                    }
                    loading.close()
                }
            }catch(error){
                    loading.close()
                console.error(error)
            }
        },
        async getInformacionAlumno(personaId, proceso, institucion){
            try{
                const vm = this
                const params = {}
                if(proceso == 'alumno'){
                    params.persona_id = personaId,
                    params.institucion_id = institucion
                }else if(proceso == 'seguimiento'){
                    params.prospecto_id = personaId,
                    params.institucion_id = institucion
                }
                const { data: response} = await alumnos.getInformacionAlumno(params)
                this.info_general = response
            }catch(error){
                console.error(error)
            }
        },
        async getHermanos(proceso, personaId){
            try{
                const alumno = {}
                if(proceso == 'usuario'){
                    alumno.user_id = personaId
                    const {data: response} = await alumnos.gethijosConPrograma(alumno)
                    this.hermanos = response
                }else{
                    if(proceso == 'alumno'){
                        alumno.persona_id = personaId
                    }else if(proceso == 'seguimiento'){
                        alumno.prospecto_id = personaId
                    }
                    const {data: response} = await alumnos.getHermanosAlumno(alumno)
                    this.hermanos = response
                }
                if(this.hermanos.length == 1){
                    if(this.hermanos[0].programas.length == 1){
                        this.idAlumno = this.hermanos[0].persona_id
                        this.getInfoGeneral(this.hermanos[0].persona_id, 'alumno')
                        this.getInformacionAlumno(this.hermanos[0].persona_id, 'alumno', this.hermanos[0].programas[0].institucion_id)
                        this.institucion_id_url = this.hermanos[0].programas[0].institucion_id
                        if(this.ruta_url){
                            this.menuShow = this.ruta_url
                        }else{
                            this.menuShow = 'perfil'
                        }
                    }
                }
            }catch(error){
                console.error(error)

            }
            
        },
        opcionMenu(opcion){
            this.menuShow = opcion
        },
        getShowOpcionMenu(){
            if((['ver-finanzas-alumno', 'gestion-finanzas', 'inscripcion-academica', 'expediente-digital', 'ver-calificaciones', 'mapa-carga-academica']).includes(this.menuShow)){
                this.showApartado = false
            }else{
                this.showApartado = true
            }
        },
        infoRegistroAcademico(info){
            this.registroAcademico = info
            this.registroCounter += 1
        }
    },
    watch:{
        persona_rol(){
        },
        proceso(){
            this.activeMenu()
        },
        menuShow(){
            this.getShowOpcionMenu()
        },
    }
}
</script>
<style lang="scss" scoped>
.md-progress-bar {
margin: 24px;
}
@mixin phone {
@media only screen and (min-width: 320px) {
    @content;
}
}
@mixin tablet {
@media only screen and (min-width: 768px) {
    @content;
}
}

@mixin desktop {
@media only screen and (min-width: 1240px) {
    @content;
}
}

.seleccionAlumno img{
    width: 100%;
}
@include tablet(){
.seleccionAlumno img{
    width: 50%;
}
}
@include tablet(){
.seleccionAlumno img{
    width: 25%;
}
}

.menuRol{
    width: 100%;
    background-color: #ffff;
    border-top:1px solid #dee2e6;
    padding: 15px 0;
    justify-content: center;
    border-radius: 0 0 25px 25px;
    text-align: center;
}

.cardInfo{
    background-color: #ffff;
    border-radius: 10px;
}
</style>
<style scoped>
.buscadorAlumnos{
    background-color: white;
    padding: 0.5rem 1rem;
}
.md-menu-content{
    max-width: 100% !important;
    border-radius: 5px 10px 10px 5px;
}
.md-menu-content-container{
    overflow: inherit !important;
    border-radius: 10px !important;
}
.opcionesMenu{
    padding: 10px;
    cursor: pointer;
}
.opcionesMenu:not(:last-child){
    border-bottom: 1px solid #E0E0E0;
}
</style>

<style>
.md-list.md-theme-default{
    border-radius: 5px 15px 15px 15px;
}

.botonCancelar{
    background-color: #FF4757;
    color: #ffff;
    display: inline-block;
    padding: 8px 12px;
    border-radius: 12px;
    cursor: pointer;
    font-size: 0.8rem;
    margin: 5px;
}

.botonEditar{
    background-color: #e2ebff;
    color: #4781ff;
    display: inline-block;
    padding: 8px 12px;
    border-radius: 12px;
    cursor: pointer;
    font-size: 0.8rem;
    margin: 5px;
}
.divisorWithLine:not(:last-child) {
    border-bottom:1px solid #dee2e6
}
.borderCarta{
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 .125rem .25rem rgba(0,0,0,.3)!important
}
.justify-space-between{
    justify-content: space-between;
}
.justify-end{
    justify-content: end;
}
.justify-start{
    justify-content: start;
}
.align-items-center{
    align-items:center;
}
</style>
